const playit = (e, sound) => {
	const elem = document.querySelector('video');

	if (elem) {
		const promise = elem.play();
		if (promise !== undefined) {
			promise
				.then(() => {
						elem.volume = sound === true ? 0.5 : 0;
						elem.autoplay = true;
						elem.muted = sound !== true;
						elem.load();
					})
				.catch((error) => {
					// eslint-disable-next-line no-console
					console.log('ERR - sound not started!', error);
				});
			}
		}
 };

const handleVideo = () => setTimeout(() => {
	const buttonHtml = '<button class="play_video_audio_btn"><i class="fas fa-volume-mute"></i><i class="fas fa-volume-up"></i></button>';
	$('.fl-row-bg-video video').parent().append(buttonHtml);
	$('.play_video_audio_btn').on('click', () => {
		$(this).toggleClass('sound_on');
		const video = $(this).parent().find('video');
		if (video) {
			playit(video, !!$(this).hasClass('sound_on'));
		}
	});
}, 1000);

(() => {
	handleVideo();
})(jQuery);
